import React, { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { NotificationList } from '../components/notifications';
import { BellIcon } from '@heroicons/react/24/outline';

const NotificationsPage = () => {
  const { user } = useContext(AuthContext);

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <div className="flex items-center">
            <BellIcon className="mr-3 h-8 w-8 text-blue-600" />
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Notifications</h1>
              <p className="mt-2 text-gray-600">View and manage all your notifications</p>
            </div>
          </div>
        </div>

        <div className="space-y-6">
          <NotificationList showAll={true} />
        </div>
      </div>
    </div>
  );
};

export default NotificationsPage;
